import useTimer from '../hooks/useTimer';
import { useTranslation } from 'react-i18next';
import React, { useContext, useEffect } from 'react';
import { Col } from 'antd';
import styled from 'styled-components';
import { Button, Header, TicketContainer } from '../components';
import { kioskContext } from '../context/kioskContext';
import { formatDateTime } from '../utils';

const FlexContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media screen and (hover: none) and (orientation: landscape) {
    flex-direction: row;
  }
`;

const MessageContainer = styled.div`
  width: 100%;

  @media screen and (hover: none) and (orientation: landscape) {
    flex: 0 0 40%;
    width: auto;
    padding-right: 24px;
  }
`;

const HeaderButtonContainer = styled.div`
  display: none;

  @media screen and (hover: none) and (orientation: landscape) {
    display: flex;
    flex-direction: column;
    margin: 1.5em 0 0 0;
  }
`;

const FooterButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 1.5em 0 0 0;
  width: 100%;

  @media screen and (hover: none) and (orientation: landscape) {
    display: none;
    margin: 0;
    width: unset;
  }

  .closeButton {
    margin-bottom: 20px;
  }
`;

const StyledLabel = styled.div`
  font-family: "Aimo Sans", sans-serif;
  font-size: inherit;
  line-height: 1em;
  font-weight: 400;
  margin-bottom: 0.5em;
`;

const StyledValue = styled.div`
  font-size: 25px;
  width: 100%;

  font-family: "Aimo Sans", sans-serif;
  font-weight: 500;
  line-height: 1.5em;
  padding: 0.16em 0.58em 0.14em 0.58em;
  white-space: ${props => props.wrap ? 'normal' : 'nowrap'};
  word-break: ${props => props.wrap ? 'break-word' : 'normal'};
`;

const StyledGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const InfoContainer = styled(Col)`
  margin-bottom: 2em;
`;

const InfoField = ({ label, value, wrap }) => {
  return (<InfoContainer>
    <StyledLabel>{label}</StyledLabel>
    <StyledValue wrap={wrap}>{value}</StyledValue>
  </InfoContainer>);
};

const CloseButton = ({ onClose }) => {
  const { t } = useTranslation();
  return <Button
    className="closeButton"
    type="primary"
    style={{ width: 'min-content' }}
    onClick={() => onClose()}>
    {t('close')}
  </Button>;
};

const ConfirmationScreen = ({ location: { state }, history, setCountryCode, setKioskState }) => {
  const onClose = () => {
    history.replace('/parking-locations');
  };

  useTimer(onClose, true);
  const { t, i18n } = useTranslation();
  const { kioskState } = useContext(kioskContext);
  const countryCode = kioskState.kiosk?.countryCode;
  const kioskUid = kioskState.kiosk?.uid;

  useEffect(() => {
    setCountryCode(countryCode);
    setKioskState(kioskState);
  }, [ kioskState, setCountryCode ]);

  const { permit } = state || {};

  if (!state?.permit) {
    onClose();
  }

  const licensePlate = permit.licensePlates.join(', ');
  const placeName = permit.placeName;
  return (<FlexContainer>
    <MessageContainer>
      {kioskUid && (
        <>
          {`ID: ${kioskUid}`}
          <br />
          <br />
        </>
      )}
      <Header>
        {t('thankYouMessage')}
      </Header>
      <HeaderButtonContainer>
        <CloseButton onClose={onClose} />
      </HeaderButtonContainer>
    </MessageContainer>

    <TicketContainer>
      <InfoField label={t('parkingValidUntil')} value={formatDateTime(permit.validity.validTo, i18n, countryCode)}/>
      <InfoField label={t('parkingStartTime')} value={formatDateTime(permit.validity.validFrom, i18n, countryCode)}/>
      <InfoField label={t('licensePlate')} value={licensePlate}/>
      <InfoField label={t('parkingPlace')} value={placeName} wrap/>
    </TicketContainer>

    <FooterButtonContainer className="btn-footer">
      <CloseButton onClose={onClose} />
    </FooterButtonContainer>
  </FlexContainer>);
};

export default ConfirmationScreen;
